var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isProfileIndex ? [_c('div', {
    class: ['mb-20', {
      'mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('PageTitle', {
    attrs: {
      "title": _vm.$t('components.tabbar.profile'),
      "bordered": true
    }
  })], 1), _vm._v(" "), _c('div', [_vm.showReferral ? [_c('div', {
    class: ['px-20 mb-20', {
      'px-md-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', {
    class: ['mb-20', {
      'mb-md-30': !_vm.deviceType.isMobile
    }]
  }, [_c('ReferralBanner')], 1)])])] : _vm._e(), _vm._v(" "), _c('div', {
    class: ['px-20 mb-20', {
      'px-md-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('Station', {
    attrs: {
      "list": _vm.allMenu
    },
    on: {
      "onClickChangeLanguage": _vm.onClickChangeLanguage,
      "onClickChangeCurrency": _vm.onClickChangeCurrency,
      "onClickLogout": function ($event) {
        return _vm.onClickLogout();
      }
    }
  })], 1)]), _vm._v(" "), _c('client-only', [_c('LanguagesModal', {
    attrs: {
      "modal-view": _vm.languagesModalView,
      "languages": _vm.languages,
      "title": _vm.$t('components.languages.modal.title'),
      "search-input-placeholder": _vm.$t('placeholder.languages.modal.language'),
      "empty-text": _vm.$t('global.no-language-available')
    },
    on: {
      "onCloseLanguagesModal": _vm.onCloseLanguagesModal
    }
  }), _vm._v(" "), _c('CurrenciesModal', {
    attrs: {
      "modal-view": _vm.currenciesModalView,
      "currencies": _vm.currencies,
      "title": _vm.$t('components.currencies.modal.title'),
      "search-input-placeholder": _vm.$t('placeholder.currencies.modal.currency'),
      "empty-text": _vm.$t('global.no-currency-available')
    },
    on: {
      "onCloseCurrenciesModal": _vm.onCloseCurrenciesModal
    }
  })], 1)], 2)] : _vm.isProfileOutter ? [_c('div', [_c('nuxt-child', {
    attrs: {
      "show-referral": _vm.showReferral
    }
  })], 1)] : [_c('div', [_vm.isLoggedIn ? [_c('div', {
    class: ['mb-20', {
      'mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    class: ['display-none', {
      'display-lg-block': !_vm.deviceType.isMobile
    }]
  }, [_c('PageTitle', {
    attrs: {
      "title": _vm.$t('components.tabbar.profile'),
      "bordered": !_vm.isShowTopTabs
    }
  })], 1), _vm._v(" "), _vm.isShowTopTabs ? [_c('div', {
    staticClass: "tw-bg-white tw-border-0 tw-border-b tw-border-solid tw-border-[#ddd]"
  }, [_c('tabs', {
    attrs: {
      "tabs": _vm.topTabs
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.getMobileKey() ? _c('div', {
    class: ['display-block', {
      'display-lg-none': !_vm.deviceType.isMobile
    }]
  }, [_c('PageTitle', {
    attrs: {
      "title": _vm.$t(_vm.getMobileKey().key),
      "bordered": true,
      "back-button": {
        url: _vm.getMobileKey().backRoute,
        hiddenAfterSizes: 'sm'
      }
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    class: ['px-0 mb-20', {
      'px-lg-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [!_vm.isProfileIndex ? [_c('div', {
    class: ['px-20', {
      'px-md-30 px-lg-0': !_vm.deviceType.isMobile
    }]
  }, [_c('Breadcrumb', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbList
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    class: ['d-grid grid-cols-6 gap-30', {
      'grid-cols-md-12': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    class: ['display-none', {
      'display-lg-flex col-span-lg-4': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('LeftMenu', {
    attrs: {
      "for-user": true,
      "user-name": _vm.userName,
      "user-badge": _vm.userBadgeData,
      "list": _vm.leftMenu
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: ['col-span-6', {
      'col-span-md-12 col-span-lg-7 col-start-lg-6': !_vm.deviceType.isMobile
    }]
  }, [_vm.routeBaseName === 'profile-index-change-email' || _vm.routeBaseName === 'profile-index-change-password' ? [_vm.userInfoData ? [_c('nuxt-child', {
    attrs: {
      "user-info": _vm.userInfoData
    }
  })] : _vm._e()] : [_c('nuxt-child', {
    attrs: {
      "show-referral": _vm.showReferral
    }
  })]], 2)])], 2)])] : _vm._e()], 2)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }